import script from "./HostingFooter.vue?vue&type=script&setup=true&lang=js"
export * from "./HostingFooter.vue?vue&type=script&setup=true&lang=js"

import "./HostingFooter.vue?vue&type=style&index=0&id=0a32db78&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0a32db78"]])

export default __exports__